import classNames from "classnames";
import React from "react";

interface DividerProps {
  className?: string;
  colorClassName?: string;
  style?: React.CSSProperties;
}

/**
 * @deprecated This component should no longer be used, use Divider instead
 */
export const HorizontalDivider = ({
  className = "mx-2 my-auto w-100",
  colorClassName = "opacity-100 border-color-gray-300",
  style,
}: DividerProps) => {
  return <hr className={classNames(className, colorClassName)} style={style} />;
};
